import Vue from 'vue';
import VueI18n from 'vue-i18n';

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

Vue.use(VueI18n)

const loadLocaleMessages = () => {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: navigator.language.slice(0, 2) || 'pt',
  fallbackLocale: 'pt',
  messages: loadLocaleMessages()
})

// validações
const i18n = new VueI18n({
  locale: navigator.language.slice(0, 2) || 'pt',
  messages: {
    pt: {
      fields: {
        // login
        email: "E-mail",
        password: "Senha",
        // adminUsers
        name: "Nome",
        hotspot: "Hotspot",
        hotspots: "Hotspots",
        password2: "Confirmar senha",
        confirmPassword: "Confirmar senha",
        // Ads
        campaignName: "Nome da campanha",
        campaingDescription: "Descrição",
        targetSelected: "Tipo de direcionamento",
        campaignTargeting: "URL de Direcionamento",
        // Profile
        currentPassword: "Senha Atual",
        newPassword: "Nova Senha",
        // Mail
        campaingName: "Nome da campanha",
        subtitle: "Assunto",
        message: "Mensagem",
        buttonLink: "Url",
        recipientName: "Nome",
        recipientEmail: "E-mail",
        // vipDevice
        macaddress: "MAC address",
        description: "Descrição"
      },
      validation: pt_BR.messages
    },
    en: {
      fields: {
        // login
        email: "E-mail",
        password: "Password",
        // adminUsers
        name: "Name",
        hotspot: "Hotspot",
        password2: "Confirm password",
        confirmPassword: "Confirm password",
        // Ads
        campaignName: "Campaing Name",
        campaingDescription: "Campaign description",
        targetSelected: "Target type",
        campaignTargeting: "Targeting URL",
        // Profile
        currentPassword: "Current Password",
        newPassword: "New Password",
        // Mail
        campaingName: "Campaing name",
        subtitle: "Subtitle",
        message: "Mensage",
        buttonLink: "Url",
        recipientName: "Name",
        recipientEmail: "E-mail",
        // vipDevice
        macaddress: "MAC address",
        description: "Description"
      },
      validation: en.messages
    },
    es: {
      fields: {
        // login
        email: "Correo electrónico",
        password: "Contraseña",
        // adminUsers
        name: "Nombre",
        hotspot: "Hotspot",
        hotspots: "Hotspots",
        password2: "Confirmar contraseña",
        confirmPassword: "Confirmar contraseña",
        // Ads
        campaignName: "Nombre de la campaña",
        campaingDescription: "Descripción",
        targetSelected: "Tipo de orientación",
        campaignTargeting: "URL de destino",
        // Profile
        currentPassword: "Contraseña actual",
        newPassword: "Nueva contraseña",
        // Mail
        campaingName: "Nombre de la campaña",
        subtitle: "Asunto",
        message: "Mensagem",
        buttonLink: "Url",
        recipienteNombre: "Nombre",
        recipienteEmail: "Correo electrónico",
        // vipDevice
        macaddress: "MAC address",
        description: "Descripción"
      },
      validation: es.messages
    },

  }
});

export { i18n };

// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
//
// // import pt_BR from "vee-validate/dist/locale/pt_BR.json";
// // import en from "vee-validate/dist/locale/en.json";
//
// Vue.use(VueI18n)
//
// const loadLocaleMessages = () => {
//   const locales = require.context(
//     '../locales',
//     true,
//     /[A-Za-z0-9-_,\s]+\.json$/i
//   )
//   const messages = {}
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i)
//     if (matched && matched.length > 1) {
//       const locale = matched[1]
//       messages[locale] = locales(key)
//     }
//   })
//   return messages
// }
//
// export default new VueI18n({
//   locale: navigator.language.slice(0, 2) || 'pt_BR',
//   fallbackLocale: 'pt_BR',
//   messages: loadLocaleMessages()
// })
//
// // const i18n = new VueI18n({
// //   locale: "en",
// //   messages: {
// //     pt_BR: {
// //       fields: {
// //         email: "email",
// //         password: "senha"
// //       },
// //       validation: pt_BR.messages
// //     },
// //     en: {
// //       fields: {
// //         email: "E-mail",
// //         password: "Password"
// //       },
// //       validation: en.messages
// //     }
// //   }
// // });
// //
// // export { i18n };
